module.exports = __webpack_public_path__ + "img/thumb_15.4075b6ea.jpg";